/**
 * Directive Dependencies
 */
import Sortable from 'sortablejs'

/**
 * Sortable Directive
 */
export default {
    inserted (el, binding) {
        /* eslint-disable no-new */
        /* eslint-disable no-unused-vars */
        var sortable = new Sortable(el, binding.value || {})
    }
}



// WEBPACK FOOTER //
// ./src/directives/sortable.js